import ContactUs from "./contact/ContactUs";
import Home from "./home/Home";

export const HomePage = Home;
export const ContactUsPage = ContactUs;
